import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHorse, Horse } from '../../contexts/HorseContext';
import { ScaleIcon, SearchIcon } from 'lucide-react';
import { Impressum } from '../Legal/Impressum';
export const HorseSelectionPage: React.FC = () => {
  const {
    horses
  } = useHorse();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showImpressum, setShowImpressum] = useState(false);
  const handleSelectHorse = (horse: Horse) => {
    // Store the selected horse ID in session storage
    sessionStorage.setItem('selectedHorseId', horse.id);
    // Navigate to the weighing page
    navigate('/weighing');
  };
  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };
  // Filter horses based on search term
  const filteredHorses = horses.filter(horse => horse.name.toLowerCase().includes(searchTerm.toLowerCase()) || horse.breed && horse.breed.toLowerCase().includes(searchTerm.toLowerCase()) || horse.birthYear.toString().includes(searchTerm));
  if (showImpressum) {
    return <Impressum onBack={toggleImpressum} data-id="element-315" />;
  }
  return <div className="w-full h-full max-w-full p-4" data-id="element-316">
      <div className="flex items-center mb-6" data-id="element-317">
        <h1 className="text-2xl font-bold" data-id="element-318">Pferd für Verwiegung auswählen</h1>
        <button onClick={toggleImpressum} className="ml-4 text-xs text-gray-600 hover:text-gray-900 hover:underline" data-id="element-319">
          Impressum
        </button>
      </div>
      {/* Search Bar */}
      <div className="relative mb-6" data-id="element-320">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-321">
          <SearchIcon size={18} className="text-gray-400" data-id="element-322" />
        </div>
        <input type="text" placeholder="Nach Name, Rasse oder Geburtsjahr suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" data-id="element-323" />
      </div>
      {horses.length === 0 ? <div className="text-center py-10" data-id="element-324">
          <p className="text-gray-500 mb-4" data-id="element-325">Keine Pferde verfügbar.</p>
          <button onClick={() => navigate('/master-data')} className="px-4 py-2 bg-[#284755] text-white rounded-md hover:bg-[#96c11f]" data-id="element-326">
            Pferd hinzufügen
          </button>
        </div> : filteredHorses.length === 0 ? <div className="text-center py-10" data-id="element-327">
          <p className="text-gray-500 mb-4" data-id="element-328">
            Keine Pferde gefunden, die "{searchTerm}" enthalten.
          </p>
          <button onClick={() => setSearchTerm('')} className="px-4 py-2 bg-[#284755] text-white rounded-md hover:bg-[#96c11f]" data-id="element-329">
            Suche zurücksetzen
          </button>
        </div> : <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-330">
          {filteredHorses.map(horse => <div key={horse.id} onClick={() => handleSelectHorse(horse)} className="bg-white rounded-lg shadow p-4 cursor-pointer hover:shadow-md transition-shadow border border-gray-200 hover:border-[#96c11f] hover:bg-[#96c11f]/5" data-id="element-331">
              <div className="flex items-center" data-id="element-332">
                <div className="bg-[#96c11f]/10 rounded-full p-3 mr-4" data-id="element-333">
                  <ScaleIcon size={24} className="text-[#96c11f]" data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <h3 className="font-medium text-lg" data-id="element-336">{horse.name}</h3>
                  <p className="text-gray-500 text-sm" data-id="element-337">
                    {horse.breed || 'Keine Rasse'}, Geburtsjahr:{' '}
                    {horse.birthYear}
                  </p>
                  {horse.weights.length > 0 ? <p className="text-sm mt-1" data-id="element-338">
                      Letzte Verwiegung:{' '}
                      {horse.weights.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())[0].weight}{' '}
                      kg
                    </p> : <p className="text-sm text-gray-400 mt-1" data-id="element-339">
                      Keine bisherigen Verwiegungen
                    </p>}
                </div>
              </div>
            </div>)}
        </div>}
    </div>;
};